import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import bannerImage from "../assets/banner.png";
import GlitchButton from "./GlitchButton";
import TransparentButton from "./TransparentButton";
import overlay from "../assets/overlay.png";
import scroll from "../assets/scroll.png";
import { Helmet } from "react-helmet-async";

const textVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, delay: i * 0.2 },
  }),
};

const containerVariants = {
  hidden: { opacity: 1 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.2 },
  },
};

export default function HeroSection({ onContactClick, onDemoClick }) {
  return (
    <header className="relative w-full h-screen min-h-[700px] px-4 md:px-12 lg:px-20 xl:px-28 overflow-hidden text-gray-50 z-[-1] bg-black">
      {/* Background Image */}
      <img
        src={bannerImage}
        alt="Fusion Spin Slots Machines" title="Fusion Spin Slots Machines"
        className="absolute top-0 left-0 w-full h-full object-cover"
      />

      {/* Motion Container */}
      <motion.div
        className="max-w-7xl mx-auto relative z-10 flex flex-col justify-center h-full"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <div className="relative w-full text-center px-4">
          {/* Soft Overlay Image */}
          <div className="absolute inset-0 h-[70vh] pointer-events-none sm:left-12 sm:top-[-8rem] top-[-5rem] ">
            <img
              src={overlay}
              alt="Overlay"
              className="h-[35rem] w-auto mx-auto sm:mx-0"
            />
          </div>

          {/* <div className=" block sm:hidden absolute inset-0 h-[70vh] pointer-events-none sm:right-20 sm:top-[-8rem] top-[-1rem] ">
            <img src={overlay} alt="Overlay" />
          </div>
          <div className="block sm:hidden absolute inset-0 h-[70vh] pointer-events-none sm:right-20 sm:top-[-8rem] top-20 ">
            <img src={overlay} alt="Overlay" />
          </div> */}

          {/* Text Content */}
          <motion.h1
            variants={textVariants}
            custom={0}
            className="relative z-10 text-3xl md:text-6xl lg:text-7xl font-extrabold tracking-tight text-white poppins-font uppercase hidden md:block"
          >
            FUSION SPIN <br />
            <motion.span
              variants={textVariants}
              custom={1}
              className="sm:inline-block px-4 flex justify-center"
            >
              Slots
            </motion.span>

            {/* <div className="flex justify-center sm:flex-none">
              <motion.span variants={textVariants} custom={1}>
                Platform
              </motion.span>
            </div> */}

            <motion.span variants={textVariants} custom={2} className="text-orange-600">
               & Games
            </motion.span>
          </motion.h1>
<motion.h1
  variants={textVariants}
  custom={0}
  className="relative z-10 
    text-4xl sm:text-5xl md:text-6xl lg:text-7xl 
    font-extrabold tracking-tight text-white poppins-font block md:hidden uppercase leading-tight"
>
  {/* Mobile layout */}
  <span className="block sm:hidden">
    <span className="block">FUSION <span className="text-orange-600">SPIN</span></span>
    <span className="block mt-2">
      <span className="text-white">SLOTS</span>
      <span className="text-orange-600"> & GAMES</span>
    </span>
  </span>

  {/* Desktop layout */}
  <span className="hidden sm:inline">
    FUSION <span className="text-orange-600">SPIN</span> 
    <span className="px-4 text-white">SLOTS</span>
    <span className="text-orange-600">& GAMES</span>
  </span>
</motion.h1>

          <motion.p
            variants={textVariants}
            custom={3}
            className="relative z-10 text-lg md:text-2xl lg:text-3xl font-medium mt-8 drop-shadow poppins-font2"
          >
            Innovative Gaming Meets Seamless User Experience
          </motion.p>
        </div>

        {/* Scroll Indicator */}
        <motion.div
          initial={{ y: 0 }}
      animate={{ y: [0, 20, 0] }}  // smooth continuous loop
      transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
          className="absolute bottom-12  left-[32%] sm:left-[42%] md:left-[44%] transform -translate-x-1/2"
        >
          <img src={scroll} alt="Scroll Indicator" />
        </motion.div>

        {/* Buttons */}
        <motion.div
          variants={containerVariants}
          className="mt-10 md:mt-16 flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-6 justify-center items-center poppins-font"
        >
          <motion.div variants={textVariants} custom={4}>
            <GlitchButton text="GET IN TOUCH" altText="GLITCH MODE" />
          </motion.div>
          <motion.div variants={textVariants} custom={5}>
            <TransparentButton texts="REQUEST A DEMO" altText="REQUEST A DEMO" />
          </motion.div>
        </motion.div>
      </motion.div>
    </header>
  );
}
